import React, { useState } from "react";
import GetRequest from "../Services/APIRequest";
import Loading from "./Loading";
import Error from "./Error";

/**
 * Mobile-first, Card-based Order Items Modal
 * - Full screen modal on mobile
 * - Company sections are collapsible
 * - Each order line item is a responsive card with all info stacked
 */
const OrderItemsDispatchInformation = ({ orderId, onClose }) => {
  const { data, error, isLoaded } = GetRequest(`/Orders/GetOrderLineDetailsById/${orderId}`);
  const [expandedCompanyIdx, setExpandedCompanyIdx] = useState(0); // By default, first is open

  if (error) return <Error data=" " />;
  if (!isLoaded) return <Loading />;

  const order = data.result;

  const toggleExpand = idx => {
    setExpandedCompanyIdx(expandedCompanyIdx === idx ? null : idx);
  };

  return (
    <div className="custom-modal-backdrop">
      <div className="custom-modal-dialog">
        <div className="custom-modal-content">
          <div className="custom-modal-header">
            <span className="custom-modal-title">{order.orderNumber}</span>
            <button
              type="button"
              className="custom-btn-close"
              onClick={onClose}
              aria-label="Close"
            >✖</button>
          </div>
          <div className="custom-modal-body">
            <div className="custom-modal-subtitle">{order.distributorName}</div>
            {order.orders && order.orders.map((item, idx) => (
              <div key={idx} className="mb-2">
                <button
                  onClick={() => toggleExpand(idx)}
                  className="custom-accordion-header"
                  aria-expanded={expandedCompanyIdx === idx}
                >
                  {item.companyName} Items&nbsp;
                  <span className="custom-caret">
                    {expandedCompanyIdx === idx ? '▲' : '▼'}
                  </span>
                </button>
                {expandedCompanyIdx === idx && (
                  <div className="custom-accordion-content">
                    {item.orderLineItemDTOList.map((line, i) => {
                      const progress = line.totalQuantityOrdered === 0
                        ? 0
                        : (line.dispatchedQuantity / line.totalQuantityOrdered) * 100;
                      let progressColor = "#ffc107"; // yellow
                      if (progress === 100) progressColor = "#198754"; // green
                      else if (progress === 0) progressColor = "#dc3545"; // red
                      const balance = line.totalQuantityOrdered - line.dispatchedQuantity;

                      return (
                        <div
                          key={i}
                          className="custom-item-card"
                        >
                          <div className="custom-item-title">{line.productName}</div>
                          <div className="custom-item-info">
                            <span><b>Ordered:</b> {line.totalQuantityOrdered}</span>
                            <span><b>Supplied:</b> {line.dispatchedQuantity}</span>
                            <span><b>Balance:</b> {balance >= 0 ? balance : 0}</span>
                          </div>
                          <div className="custom-progress-bar-bg">
                            <div
                              className="custom-progress-bar-fg"
                              style={{
                                width: `${progress}%`,
                                backgroundColor: progressColor,
                                borderRadius: progress === 100 ? 10 : "10px 0 0 10px"
                              }}
                              aria-valuenow={progress}
                              aria-valuemin={0}
                              aria-valuemax={100}
                              role="progressbar"
                            >
                              {line.totalQuantityOrdered > 0
                                ? `${Math.round(progress)}%`
                                : "Preclosed / Cancelled"}
                            </div>
                          </div>
                          {line.isPreClosed && (
                            <div className="custom-preclosed-details">
                              <div><b>Preclosed Details:</b></div>
                              <div><b>Quantity:</b> {line.preCloseQty}</div>
                              <div><b>Date:</b> {line.preCloseDate}</div>
                              <div><b>Reason:</b> {line.preCloseReason}</div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderItemsDispatchInformation;
